export default class contactManager {
    constructor() {
        this.status = {
            flg : false,
            containFlg: false
        };

        this.form = document.getElementById("js__form");
        this.check = document.querySelectorAll(".js__required");
        this.submitBtn = document.getElementById("js__submit");
        this.error = document.getElementsByClassName('is-error');
        this.inputTel = document.querySelectorAll("input[type=tel]");
        this.target = '';
    }

    init(){
        this.validate();
        this.submit();

        //blur
        this.blur();

        //change
        this.change();

        //submit
        if(this.form) this.form.addEventListener("input",()=> {
            this.validate();
            this.submit();
        });
        if(this.form) this.form.addEventListener("blur",()=> {
            this.validate();
            this.submit();
        });

        //[ 半角へ変換 ]
        for(let i = 0; i < this.inputTel.length; i++){
            this.inputTel[i].addEventListener("change",() => {
                let _text  = this.inputTel[i].value;
                let _han = _text.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
                this.inputTel[i].value = _han;
            });
        }

        //[ 数字のみ入力 ]
        for(let i = 0; i < this.inputTel.length; i++){
            this.inputTel[i].addEventListener('keypress', (e) => {
                let _k = e.keyCode;
                // 0～9, テンキ―0～9, スペース, backspace, delete, →, ←, 以外は入力キャンセル
                if(!((_k >= 48 && _k <= 57) || (_k >= 96 && _k <= 105) || _k === 32 || _k === 8 || _k === 46 || _k === 39 || _k === 37)) {
                    e.preventDefault();
                }
            });
        }
    }

    submit(){


        if(!this.submitBtn) return;
        if(this.status.flg && this.status.containFlg){
            this.submitBtn.parentNode.classList.remove('disabled');
            this.submitBtn.disabled = false;
        }else{
            this.submitBtn.parentNode.classList.add('disabled');
            this.submitBtn.disabled = true;
        }
    }

    blur(){
        for(let i = 0; i < this.check.length ; i++){
            this.check[i].addEventListener('blur',()=>{
                this.target = this.check[i];
                this.errorSet();
                this.emailCheck();
                this.validate();
                this.submit();
            });
        }
    }

    change(){
        for(let i = 0; i < this.check.length ; i++){
            this.check[i].addEventListener('change',()=>{
                this.target = this.check[i];
                this.errorSet();
                this.emailCheck();
                this.validate();
                this.submit();
            });
        }
    }

    emailCheck(){
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;


        if(_id.match(/email/g)){
            if(_val==""){
                this.errorSet();
            }else{
                if(!_val.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)){
                    this.reset();
                    this.target.parentNode.parentNode.classList.add('is-error-email');
                }
            }
        }
    }

    errorSet(){
        this.reset();
        if(this.target.value===""){
            this.target.parentNode.parentNode.classList.add('is-error');
        }
    }

    validate(){
        let i=0;
        while(i < this.check.length){
            if(this.check[i].value === ''){
                this.status.containFlg = false;
                break;
            }else{
                this.status.containFlg = true;
            }
            i++;
        }

        if(document.getElementsByClassName('is-error').length > 0 || document.getElementsByClassName('is-error-email').length > 0) {
            this.status.flg = false;
        }else{
            this.status.flg = true;
        }
    }

    reset(){
        if(document.getElementsByClassName('is-error')) {
            this.target.parentNode.parentNode.classList.remove('is-error');
        }
        if(document.getElementsByClassName('is-error-email')){
            this.target.parentNode.parentNode.classList.remove('is-error-email');
        }
    }
}